import type { FaireThemeEntity } from "../../entity_types/theme";

export const paper_goods_planning: FaireThemeEntity = {
  token: "paper-goods-planning",
  type: "theme",
  retailerToken: "r_rk3595bqqg",
  name: "Paper Goods & Planning",
  description: "Journals, planners, and cards for your lifestyle mix",
  bgColor: "#D6E0F0",
  tileBgColor: "#8a6d28",
  productTokens: [
    "p_ttq445duu9",
    "p_gv2twn33tr",
    "p_g242z998ff",
    "p_rrfgdvac4p",
    "p_bzspsx8bmy",
    "p_bvmgg7mbhu",
    "p_yzq5bsjvdz",
    "p_vmc9rzbk4c",
    "p_b24h2rg55x",
    "p_xbfdvzf4w3",
    "p_m9ym98ftmh",
    "p_ch6apwi6mz",
    "p_enc9u3r4un",
    "p_5rjg9gh45d",
    "p_qacktwqtsr",
    "p_ckylep91",
    "p_979s7d9zse",
    "p_v7hnggcq2d",
    "p_69dbxvud2d",
    "p_knwydze7fm",
  ],
  exactProducts: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:50:10Z",
    importedBy: "retailer-themes-entity-migration",
  },
};
